import { useEffect, useState } from "react";
import type { ReactNode } from "react";
import type { ToneKey } from "@/mocks/chigua";

const toneSoft: Record<ToneKey, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-700",
  secondary: "bg-secondary-100 text-secondary-700",
  cream: "bg-background-100 text-foreground-700",
};

export default function Tag({
  tone = "cream",
  children,
}: {
  tone?: ToneKey;
  children: ReactNode;
}) {
  return (
    <span
      className={`inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-semibold leading-none ${toneSoft[tone]}`}
    >
      {children}
    </span>
  );
}